var ref, ref1;
/**
 * define global variables here
 */ // server root directory
// import { configJsonGet } from 'portal-common/http/config/local/loader';
// global.SERVER_ROOT = __dirname;
// Object.defineProperty(global, '__stack', {
//   get: function get() {
//     const orig = Error.prepareStackTrace;
//     Error.prepareStackTrace = (_, stack) => stack;
//     const err = new Error();
//     Error.captureStackTrace(err, get);
//     const stack = err.stack;
//     Error.prepareStackTrace = orig;
//     return stack;
//   },
// });
// 用于语义化区分当前代码执行环境是 `client` 还是 `server`
export var isServerContext = !!(process === null || process === void 0 ? void 0 : (ref = process.env) === null || ref === void 0 ? void 0 : ref.SSR);
export var isClientContext = !(process === null || process === void 0 ? void 0 : (ref1 = process.env) === null || ref1 === void 0 ? void 0 : ref1.SSR);
export var _ = require('lodash');
// global.logger = require('./libs/logger');
// global.E = require('./libs/error');
// require('./libs/i18n');
// TODO: 待优化
export var L = {
    EN: 'en',
    JP: 'jp',
    KO: 'ko',
    ZH: 'zh',
    PT: 'pt',
    IND: 'ind'
}; // 提供给前端 Service 层实现 Universual Service
 // global.serviceMap = require('./services/edu');
